import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.ResetPasswordPage', {
    title: 'Reset your password',
    loginNowButtonText: 'Log in now',
});
